import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_goalgeous-hub/artifacts/ad5dhro0_Untitled%20design.png";

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'The Power Room', path: '/power-up' },
  { name: 'SHOCK THE BODY', path: '/shock-the-body' },
  { name: 'GOALGEOUS University', path: '/goalgeous-university' },
  { name: 'Club Deuces', path: '/club-deuces' },
  { name: 'GOAL-TRITION', path: '/goal-trition' },
  { name: 'Accountability Chats', path: '/accountability-check' },
  { name: 'Instructors', path: '/instructors' },
  { name: 'Book Now', path: '/book-now', highlight: true },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav data-testid="main-navbar" className="fixed top-0 w-full z-50 glass border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
            <img 
              src={LOGO_URL} 
              alt="Power Up Your Fitness" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
                className={`text-[10px] font-bold uppercase tracking-wider transition-colors whitespace-nowrap ${
                  link.highlight
                    ? 'bg-brand-lime text-brand-black px-3 py-1 hover:bg-brand-pink hover:text-white'
                    : location.pathname === link.path
                      ? 'text-brand-lime'
                      : 'text-white hover:text-brand-lime'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsOpen(!isOpen)}
            className="xl:hidden text-white hover:text-brand-lime transition-colors"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div data-testid="mobile-menu" className="xl:hidden glass border-t border-white/5">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-link-${link.path.replace('/', '') || 'home'}`}
                onClick={() => setIsOpen(false)}
                className={`block text-sm font-bold uppercase tracking-widest transition-colors ${
                  link.highlight
                    ? 'bg-brand-lime text-brand-black px-4 py-2 text-center hover:bg-brand-pink hover:text-white'
                    : location.pathname === link.path
                      ? 'text-brand-lime'
                      : 'text-white hover:text-brand-lime'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
